import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

type Props = {
	onClose: () => void;
	onSeeDcrForm: () => void;
	isDirty: boolean;
	isValid: boolean;
};

export const PickCountryModalActions = ({
	onClose,
	onSeeDcrForm,
	isDirty,
	isValid
}: Props) => {
	const { t } = useTranslation();

	return (
		<>
			<Button variant='text' onClick={onClose}>
				{t('Cancel')}
			</Button>
			<Button
				disabled={!isDirty || !isValid}
				variant='contained'
				onClick={onSeeDcrForm}
			>
				{t('Next')}
			</Button>
		</>
	);
};
